import { cn } from '@/lib/cn';

interface BrandProps {
  variant?: 'mono' | 'two-tone';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizes = {
  sm: 'text-base',
  md: 'text-xl',
  lg: 'text-3xl',
};

/**
 * Wordmark. Uses a tight monospace at small sizes (CB-radio nod), and the
 * Inter logotype at large. "BREAKER" sits in ink; the full stop carries the
 * identity blue — chosen 2026-08-16, replacing the old red-R treatment.
 */
export function Brand({ variant = 'two-tone', size = 'md', className }: BrandProps) {
  return (
    <span
      className={cn(
        'inline-flex items-baseline font-semibold tracking-tight',
        sizes[size],
        className,
      )}
    >
      <span className={cn(variant === 'mono' ? '' : 'text-breaker-ink')}>BREAKER</span>
      <span className={cn(variant === 'mono' ? '' : 'text-breaker-identity')}>.</span>
    </span>
  );
}
